"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaCarouselSlide = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _Carousel = require("../Carousel");
var _Image = require("../Image");
var _styles = require("../Image/styles");
var _Video = require("../Video");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const MediaCarouselSlide = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    type
  } = props;
  if (type === 'image') {
    const {
      src,
      disableLazyLoad,
      imageProps,
      shouldLoad
    } = props;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.CarouselSlide, {
      minWidth: "100%",
      testId: getTestId(_constants.IMAGE_SLIDE),
      children: disableLazyLoad ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.EagerLoadImage, {
          alt: imageProps?.alt ?? src,
          "data-testid": getTestId(_common.IMAGE),
          src: src,
          ...imageProps
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
        src: shouldLoad ? src : undefined,
        placeholderAbsolute: imageProps?.placeholderAbsolute ?? true,
        ...(shouldLoad ? imageProps : {})
      })
    });
  }
  const {
    src,
    videoProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.CarouselSlide, {
    minWidth: "100%",
    testId: getTestId(_constants.VIDEO_SLIDE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Video.Video, {
      playInLoop: false,
      src: src,
      ...videoProps
    })
  });
};
exports.MediaCarouselSlide = MediaCarouselSlide;
//# sourceMappingURL=MediaCarouselSlide.js.map